export const Constants = {
  roleDropdownData: [
    {
      id: "P",
      value: "Primary",
    },
    {
      id: "S",
      value: "Secondary",
    },
    {
      id: "T",
      value: "Technical",
    },
  ],
  maritalStatusCodes: {
    M: "Married",
    S: "Single",
    U: "Unmarried",
  },
  ownerShipPhases: {
    A: "Accumulation",
    D: "Deferral",
    P: "Payout",
    W: "Withdrawal",
    T: "Terminated",
  },
  electionEligibilityCodes: {
    E: "Eligible",
    N: "Not Eligible",
    Z: "Elected",
  },
  employmentStatuses: {
    A: "Active",
    D: "Disabled",
    R: "Retired",
    T: "Terminated",
    N: "No",
  },
  AGE_COLUMN: 0,
  SINGLE_PRICE_COLUMN: 1,
  JOINT_PRICE_COLUMN: 2,
  PRODUCT_STATUS_ACTIVE: "active",
  PRODUCT_STATUS_INACTIVE: "inactive",
  PRODUCT_STATUS_CLOSED: "closed",
  productTypes: [
    {
      id: "F",
      label: "Fixed",
    },
    {
      id: "I",
      label: "GMIB",
    },
    {
      id: "W",
      label: "GMWB",
    },
  ],
  productDistribution: {
    header: "Product Distribution *",
    data: [
      {
        name: "In-Plan",
        label: "In-Plan",
        id: "Y",
      },
      {
        name: "Retail",
        label: "Retail",
        id: "N",
      },
    ],
  },
  incomeBaseReset: {
    header: "Income Base Reset",
    data: [
      {
        name: "Calendar year",
        label: "Calendar year",
        id: "C",
      },
      {
        name: "Birth Date",
        label: "Birth Date",
        id: "B",
      },
      {
        name: "Certificate anniversary",
        label: "Certificate Anniversary",
        id: "T",
      },
    ],
  },
  incomeBaseResetFrequency: {
    header: "Income Base Reset Frequency",
    data: [
      {
        name: "Income Base Reset Frequency Monthly",
        label: "Monthly",
        id: "M",
      },
      {
        name: "Income Base Reset Frequency Quarterly",
        label: "Quarterly",
        id: "Q",
      },
      {
        name: "Income Base Reset Frequency Semiannually",
        label: "Semiannually",
        id: "S",
      },
      {
        name: "Income Base Reset Frequency Annually",
        label: "Annually",
        id: "A",
      },
      {
        name: "Income Base Reset Frequency One Time",
        label: "One Time",
        id: "O",
      },
    ],
  },
  yesOrNo: (header) => {
    return {
      header: header,
      data: [
        {
          name: header + " Yes",
          label: "Yes",
          id: "Y",
        },
        {
          name: header + " No",
          label: "No",
          id: "N",
        },
      ],
    };
  },
  weekendHolidayBenefitBaseReset: {
    header: "Weekend/Holiday Income Base Reset",
    data: [
      {
        name: "Prior Business Day",
        label: "Prior Business Day",
        id: "P",
      },
      {
        name: "Next Business Day",
        label: "Next Business Day",
        id: "N",
      },
    ],
  },
  feeSchedule: {
    header: "Fee Schedule",
    data: [
      {
        name: "Monthly",
        label: "Monthly",
        id: "M",
      },
      {
        name: "Quarterly",
        label: "Quarterly",
        id: "Q",
      },
      {
        name: "Semiannually",
        label: "Semiannually",
        id: "S",
      },
      {
        name: "Annually",
        label: "Annually",
        id: "A",
      },
    ],
  },
  benefitBaseResetBasedOnBirthday: {
    header: "QDRO Income Base Reset Based on",
    data: [
      {
        name: "Birthdate of QDRO Owner",
        label: "Birthdate of QDRO Owner",
        id: "S",
      },
      {
        name: "Birthdate of Original Owner",
        label: "Birthdate of Original Owner",
        id: "O",
      },
    ],
  },
  processIncomeBaseAndEnrollmentConsentRequired: {
    header: "Process Income Base Reset (W/D)",
    data: [
      {
        name: "Prior Day",
        label: "Prior Day",
        id: "P",
      },
      {
        name: "Current Day",
        label: "Current Day",
        id: "C",
      },
    ],
  },
  consentRequiredAndContractCertificateProcessing: {
    header: "Payment Rate Age Basis",
    data: [
      {
        name: "Owner",
        label: "Owner",
        id: "O",
      },
      {
        name: "Younger of owner or spouse",
        label: "Younger of owner or spouse",
        id: "Y",
      },
      {
        name: "Combination of owner and spouse",
        label: "Combination of owner and spouse",
        id: "C",
      },
    ],
  },
  ageCalculationMethod: {
    header: "Age Calculation Method",
    data: [
      {
        name: "Birthdate",
        label: "Birthdate",
        id: "D",
      },
      {
        name: "12/31 of current year",
        label: "12/31 of current year",
        id: "B",
      },
    ],
  },
  gmwbCalculationMethod: {
    header: "GMWB Calculation Method",
    data: [
      {
        name: "Standard Payment Rate",
        label: "Standard Payment Rate",
        id: "S",
      },
      {
        name: "Weighted Payment Rate with NUV",
        label: "Weighted Payment Rate with NUV",
        id: "W",
      },
      {
        name: "Transaction Type Payment Rate",
        label: "Transaction Type Payment Rate",
        id: "T",
      },
    ],
  },
  removeEnrollmentDateAfterLiquidation: {
    header: "Remove Enrollment Date After Liquidation",
    data: [
      {
        name: "Yes - Retain ownership phase",
        label: "Yes - Retain ownership phase",
        id: "Y",
      },
      {
        name: "Yes - Return to accumulation phase",
        label: "Yes - Return to accumulation phase",
        id: "A",
      },
      {
        name: "Remove Enrollment Date After Liquidation No",
        label: "No",
        id: "N",
      },
    ],
  },
  allowMultipleInvestmentVehicles: {
    header: "Allow Multiple Investment Vehicles",
    data: [
      {
        name: "Yes - Do not combine multiple investment vehicles",
        label: "Yes - Do not combine multiple investment vehicles",
        id: "D",
        disabled: true,
      },
      {
        name: "Yes - Combine multiple investment vehicles",
        label: "Yes - Combine multiple investment vehicles",
        id: "Y",
      },
      {
        name: "Allow Multiple Investment Vehicles No",
        label: "No",
        id: "N",
      },
    ],
  },
  defaultProductData: {
    productId: null,
    productSponsorId: "",
    lastMntDateTime: "",
    lastMntOpId: "",
    name: "",
    description: "",
    externalId: null,
    setupCompleteDt: "",
    activeDt: "",
    closedDt: "",
    reopenDt: "",
    newInvestorCloseDt: "",
    newPurchaseCloseDt: "",
    setupComplete: "",
    status: "",
    productType: "F",
    inPlanCode: "",
    productOptionSettings: [
      {
        productSponsorId: "",
        productOptionId: "1",
        value: "",
        type: "PRODUCT_MIN_BENEFIT_BASE_AMOUNT",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "2",
        value: "",
        type: "PRODUCT_MIN_INITIAL_PURCHASE_AMOUNT",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "3",
        value: "",
        type: "PRODUCT_MIN_ADDITIONAL_PURCHASE_AMOUNT",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "4",
        value: "",
        type: "PRODUCT_MAX_TOTAL_PURCHASE_AMOUNT",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "5",
        value: "",
        type: "PRODUCT_ENROLLMENT_CONSENT_REQUIRED_CODE",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "6",
        value: "",
        type: "PRODUCT_GUARANTEED_BENEFITS_AGE",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "7",
        value: "",
        type: "PRODUCT_ELIGIBLE_WITHDRAWAL_AGE",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "8",
        value: "",
        type: "PRODUCT_MIN_ENTRY_AGE",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "9",
        value: "",
        type: "PRODUCT_MAX_ENTRY_AGE",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "10",
        value: "",
        type: "PRODUCT_BENEFIT_BASE_RESET_FREQUENCY",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "11",
        value: "",
        type: "PRODUCT_BENEFIT_BASE_RESET",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "12",
        value: "",
        type: "PRODUCT_MIN_PURCHASE_TABLE_AGE_RANGE",
        productType: "F",
      },
      {
        productSponsorId: "",
        productOptionId: "13",
        value: "",
        type: "PRODUCT_MAX_PURCHASE_TABLE_AGE_RANGE",
        productType: "F",
      },
      {
        productSponsorId: "",
        productOptionId: "14",
        value: "",
        type: "PRODUCT_MIN_PAYMENT_TABLE_AGE_RANGE",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "15",
        value: "",
        type: "PRODUCT_MAX_PAYMENT_TABLE_AGE_RANGE",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "16",
        value: "",
        type: "PRODUCT_MANDATORY_WITHDRAWAL_AGE",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "17",
        value: "",
        type: "PRODUCT_MAX_BENEFIT_BASE_AMOUNT",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "18",
        value: "",
        type: "PRODUCT_MIN_PORTFOLIO_BALANCE_PAYOUT_TRIGGER_AMOUNT",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "19",
        value: "",
        type: "PRODUCT_REDUCE_BENEFIT_BASE_BY_RMD_EXCESS",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "20",
        value: "",
        type: "PRODUCT_MIN_FUNDING_PERIOD",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "21",
        value: "",
        type: "ACCOUNT_CALCULATION_AGE_CODE",
        productType: "F",
      },
      {
        productSponsorId: "",
        productOptionId: "22",
        value: "",
        type: "CONTRACT_CERTIFICATE_NUMBER_PROCESSING_REQUIRED",
        productType: "ALL",
      },
      {
        productSponsorId: "",
        productOptionId: "23",
        value: "",
        type: "EXCHANGE_RESTRICTION_AGE_YEAR_COUNT",
        productType: "F",
      },
      {
        productSponsorId: "",
        productOptionId: "24",
        value: "",
        type: "EXCHANGE_RESTRICTION_AGE_MONTH_COUNT",
        productType: "F",
      },
      {
        productSponsorId: "",
        productOptionId: "25",
        value: "",
        type: "LOCK_OUT_PERIOD_COUNT",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "26",
        value: "",
        type: "MAX_BENEFIT_BASE_RESET_AGE_COUNT",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "27",
        value: "",
        type: "CONTR_LIMIT_ON_TRANSFERS_AND_ROLLOVERS_MAX_AMOUNT",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "28",
        value: "",
        type: "CONTR_LIMIT_ON_TRANSFERS_AND_ROLLOVERS_MONTH_PERIOD",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "29",
        value: "",
        type: "ALLOWABLE_AGE_DIFFERENT_FOR_JOINT_ANNUITANT_YEARS_COUNT",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "30",
        value: "",
        type: "PRODUCT_ELIGIBLE_WITHDRAWAL_AGE_MONTH",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "31",
        value: "",
        type: "WEEKEND_HOLIDAY_BENEFIT_BASE_RESET",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "32",
        value: "",
        type: "FEE_SCHEDULE",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "33",
        value: "",
        type: "GMWB_CALCULATION_METHOD",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "34",
        value: "",
        type: "PROCESS_INCOME_BASE_RESET",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "35",
        value: "",
        type: "PAYMENT_RATE_AGE_BASIS",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "36",
        value: "",
        type: "PRODUCT_GUARANTEED_BENEFITS_AGE_2",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "37",
        value: "",
        type: "PRODUCT_GUARANTEED_BENEFITS_AGE_3",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "38",
        value: "",
        type: "PROJECTION_AND_ELECTION_PROCESSING_REQUIRED",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "39",
        value: "",
        type: "INCOME_BASE_RESET_AT_ELECTION_REQUIRED",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "40",
        value: "",
        type: "REMOVE_ENROLLMENT_DATE_AFTER_LIQUIDATION",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "41",
        value: "",
        type: "ALLOW_MULTIPLE_INVESTMENT_VEHICLES_REQUIRED",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "42",
        value: "",
        type: "BENEFIT_BASE_RESET_BASED_ON_BIRTHDAY",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "43",
        value: "",
        type: "PEND_ELECTION_AFTER_MARKET_CLOSES",
        productType: "W",
      },
      {
        productSponsorId: "",
        productOptionId: "44",
        value: "",
        type: "PRODUCT_ONE_TIME_STEP_UP_AGE",
        productType: "W",
      },
    ],
  },
};
